<template>
  <div style="font-family: -apple-system-font,PingFang SC,Helvetica Neue,Helvetica,STHeiTi,sans-serif;">
    <div class="carousel">
      案例精选
    </div>
    <div class="case_main">
      <div class="case_top">
        <div class="case_title">金沙县环保大数据监管平台</div>
        <div class="case_time">
          <img
            src="../../assets/images/developerCommunity/dev_time.png"
            alt=""
          />
          <span>2020/06/12</span>
        </div>
        <hr />
      </div>
      <div class="case_detail">
        <!-- <div class="model"> -->
        <!-- <div class="model_title">【企业介绍】</div> -->
        <!-- <div class="section"></div> -->
        <!-- </div> -->
        <div class="model">
          <div class="model_title">【项目概况】</div>
          <div>
            <div class="section">
              金沙县智慧环保大数据项目建设基于智慧环保顶层设计，旨在为环保局提出“一网、一平台、两中心、N应用”的智慧环保整套解决方案。“一网”即搭建环保智能监测物联网，“一平台”即搭建环保云计算平台，“两中心”即搭建环保应急指挥中心与环保数据中心，“N应用”即建设网上服务大厅、环境评价、污染管理、固废与辐射管理、网格化管理、环境监察、环境监测、生态红线、应急指挥、环保一张图、环保一企一档、领导综合管理等智慧应用。
            </div>
            <div class="section">
              <img
                src="../../assets/images/zhongzaisheng/detail0/1.png"
                alt=""
              />
            </div>
             <div class="section">
              <img
                src="../../assets/images/zhongzaisheng/detail0/3.png"
                alt=""
              />
            </div>
             <div class="section">
              <img
                src="../../assets/images/zhongzaisheng/detail0/2.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="model">
          <div class="model_title">【项目效果】</div>
          <div class="section">
            提高企业信息更新效率以及申报效率，并且可以实时查看企业各类信息。并通过大数据对企业数据进行分析来创建企业画像。
          </div>
          <div class="section">
            有效提高监管人员对于企业的监管和执法效率，并且通过手机APP可以随时查看所管辖污染源信息。
          </div>
          <div class="section">
            利用GIS技术将污染源各类信息集中在一张图上进行展示，用户可以通过地图直观的了解到所管辖区域的企业信息，污染源数据，各类监测设备状态
          </div>
          <div class="section">
            保证清扫作业时间内全额作业，如在作业时间内长时间停驶将第一时间预警并核实确认。
          </div>

          <div class="section">
            通过互联网将企业处罚，政府公告对相关信息进行公开。主要包括公开指南、公开目录、公开规定、依申请公开和公开意见箱等。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CaseZhongZaiShengDetail1",
  data() {
    return {
      detailId: this.$route.params.id
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.init();
  },
  methods: {
    init() {
      console.log(this.detailId);
    }
  }
};
</script>

<style lang="scss" scoped>
.carousel {
  background-color: #1a1a1a;
  height: 4rem;
  text-align: center;
  line-height: 4rem;
  font-size: 0.4rem;
  color: #ffffff;
}

.case_main {
  padding: 0 2.4rem;
  margin-bottom: 0.3rem;

  .case_top {
    margin-top: 0.6rem;

    .case_title {
      font-size: 0.32rem;
    }

    .case_time {
      margin-top: 0.2rem;
      font-size: 0.18rem;
      color: #999999;
      display: flex;
      align-items: center;
      img {
        width: 0.2rem;
        height: 0.2rem;
        margin-right: 0.1rem;
      }
    }

    hr {
      margin-top: 0.4rem;
      color: #cccccc;
    }
  }

  .case_detail {
    margin: 0 2.2rem;
    margin-bottom: 0.6rem;
    color: #000000;
    img {
      width: 100%;
    }
    .model {
      margin-top: 0.2rem;
      .model_title {
        font-size: 0.22rem;
        font-weight: 600;
      }
      .imageContainer {
        width: 100%;
        display: flex;
        justify-content: space-around;
        // padding-left: 2.0em;
        img {
          width: 2.4rem;
        }
      }
      .section {
        padding-left: 0.12rem;
        text-indent: 2em;
        line-height: 0.36rem;
        font-size: 0.18rem;
        margin-top: 0.12rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detail_page/CaseZhongZaiShengDetail0.vue